import Api from "../common/Api";
import * as process from "process";
import {SmcnCertModel} from "app/model/rp/SmcnCertModel";
import {SmcnCertRECModel} from "app/model/rp/SmcnCertRECModel";
import {FileInfoModel} from "app/model/common/file";

export class SmcnCertService extends Api {

  private static service: SmcnCertService;
  private static UPDATE_URL: string = process.env['REACT_APP_URL_RP'] + '/smcnCert/smcnCertUpdate';
  private static DELETE_DETAIL_URL: string = process.env['REACT_APP_URL_RP'] + '/smcnCert/smcnCertDetailDelete';
  private static DELETE_LIST_URL: string = process.env['REACT_APP_URL_RP'] + '/smcnCert/smcnCertListDelete';
  private static DETAIL_URL: string = process.env['REACT_APP_URL_RP'] + '/smcnCert/smcnCertDetail';
  private static REC_UPDATE_URL: string = process.env['REACT_APP_URL_RP'] + '/smcnCert/smcnCertRecUpdate';
  private static REC_DETAIL_URL: string = process.env['REACT_APP_URL_RP'] + '/smcnCert/smcnCertRecDetail';
  private static REC_DELETE_DETAIL_URL: string = process.env['REACT_APP_URL_RP'] + '/smcnCert/smcnCertRecDetailDelete';
  private static REC_DELETE_LIST_URL: string = process.env['REACT_APP_URL_RP'] + '/smcnCert/smcnCertRecListDelete';
  private static SUM_EACH: string = process.env['REACT_APP_URL_RP'] + '/smcnCert/qntBySmcnCertByUser';
  private static TOTAL_SUM_EACH: string = process.env['REACT_APP_URL_RP'] + '/smcnCert/totalQntBySmcnCertByUser';
  private static SUM_ALL_COST_URL: string = process.env['REACT_APP_URL_RP'] + '/smcnCert/smcnCertSumAllCost';
  private static YEARLY_QNT_URL: string = process.env['REACT_APP_URL_RP'] + '/smcnCert/yearlyQnt';
  private static FILE_URL: string = process.env["REACT_APP_URL_RP"] + "/files/file";

  public static getInstance(): SmcnCertService {
    if (!SmcnCertService.service) {
      SmcnCertService.service = new SmcnCertService();
    }
    return SmcnCertService.service;
  }

  public async updateSmcnCert(smcnCert: FormData) {
    return await super.post<SmcnCertModel>(SmcnCertService.UPDATE_URL, smcnCert)
  }

  public async deleteSmcnCert(smcnCert: SmcnCertModel | null) {
    return await super.delete<SmcnCertModel>(SmcnCertService.DELETE_DETAIL_URL, smcnCert)
  }

  public async  downloadFile(file: FileInfoModel) {
    const param = {
      filePath: file.pthNm,
      fileName: file.fileNm,
      originalFileName: file.realNm,
    };
    await super.download(SmcnCertService.FILE_URL, param);
  }

  public async deleteSmcnCerts(smcnCerts: SmcnCertModel[]) {
    return await super.post<SmcnCertModel[]>(SmcnCertService.DELETE_LIST_URL, {deleteRows: smcnCerts})
  }

  public async detailSmcnCert(smcnCertId: string) {
    return await super.get<SmcnCertModel>(SmcnCertService.DETAIL_URL, {smcnCertId: smcnCertId})
  }

  public async updateSmcnCertREC(smcnCertRec: FormData) {
    return await super.post<SmcnCertRECModel>(SmcnCertService.REC_UPDATE_URL, smcnCertRec)
  }

  public async detailSmcnCertREC(smcnCertRecId: string) {
    return await super.get<SmcnCertRECModel>(SmcnCertService.REC_DETAIL_URL, {smcnCertRecId: smcnCertRecId})
  }

  public async deleteSmcnCertREC(smcnCertRec: SmcnCertRECModel | null) {
    return await super.delete<SmcnCertRECModel>(SmcnCertService.REC_DELETE_DETAIL_URL, smcnCertRec)
  }

  public async deleteSmcnCertRECs(smcnCertRec: SmcnCertRECModel[]) {
    return await super.post<SmcnCertRECModel>(SmcnCertService.REC_DELETE_LIST_URL, {deleteRows: smcnCertRec})
  }

  /**
   * @description smcnCert 이행수단 실적 사용 및 수정 완료 2025.08.06
   */
  public async getSumEach(requestYear: String) {
    return await super.get<any>(SmcnCertService.SUM_EACH, {year: requestYear});
  }

  // rec 실적 등록 고려 X(재생에너지 없는 경우도 포함)
  public async getTotalSumEach(requestYear: String) {
    return await super.get<any>(SmcnCertService.TOTAL_SUM_EACH, {year: requestYear});
  }

  /**
   * @description 이행비용 합계
   * @description smcnCert 이행수단 실적 사용 및 수정 완료 2025.08.06
   */
  public async getAllSumSmcnCertCost(requestYear: String) {
    return await super.get<any>(SmcnCertService.SUM_ALL_COST_URL, {requestYear: requestYear})
  }

  /**
   *
   * @description smcnCert 이행수단 실적 사용 및 수정 완료 2025.08.06
   */
  public async getYearlyQnt(year: string) {
    return await super.get<any>(SmcnCertService.YEARLY_QNT_URL, {year: year});
  }
}